function ContactMe() {
    return (
        <section>
            {/* Contact form or details here */}
        </section>
    );
}

export default ContactMe;
